import { Routes } from '@angular/router';
import { gestaoFinanceiraRoutes } from '@/features/gestao/gestao-financeira/gestao-financeira.routes';
import { gestaoAdministrativaRoutes } from '@/features/gestao/gestao-administrativa/gestao-administrativa.routes';
import { gestaoComissoesRoutes } from '@/features/gestao/gestao-comissoes/gestao-comissoes.routes';

export const gestaoRoutes: Routes = [...gestaoFinanceiraRoutes, ...gestaoAdministrativaRoutes, ...gestaoComissoesRoutes];
export default gestaoRoutes;
